/**
 * The slot registrations of `web/types` (deliverable 13): the type pill (`header.pills.type`,
 * order 10) and the filled-fields pill (`header.pills.fields`, order 60).
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/types']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { FieldsPill } from './pills/FieldsPill.js';
import { TypePill } from './pills/TypePill.js';

export const owner: WorkPackageId = '1.B-2';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 10, owner: '1.B-2', component: TypePill },
  { slot: 'header.pills', order: 60, owner: '1.B-2', component: FieldsPill },
];
